import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Face = ({ happy }) => (
  <svg viewBox="0 0 64 64" className="w-20 h-20" aria-hidden="true">
    <circle cx="32" cy="32" r="30" fill={happy ? "#facc15" : "#93c5fd"} stroke="#0f172a" strokeWidth="2" />
    <circle cx="22" cy="26" r="4" fill="#0f172a" /><circle cx="42" cy="26" r="4" fill="#0f172a" />
    {happy ? <><path d="M18 38 Q32 54 46 38" fill="#fb7185" stroke="#0f172a" strokeWidth="2.5" /><circle cx="14" cy="36" r="4" fill="#fda4af" /><circle cx="50" cy="36" r="4" fill="#fda4af" /></>
      : <><path d="M20 48 Q32 38 44 48" fill="none" stroke="#0f172a" strokeWidth="2.5" strokeLinecap="round" /><path d="M44 30 q4 8 0 12 q-4 -4 0 -12" fill="#38bdf8" /></>}
  </svg>
);

export default function Survey() {
  const { token } = useParams();
  const [s, setS] = useState(null); const [err, setErr] = useState(""); const [rating, setRating] = useState("");
  const [note, setNote] = useState(""); const [photo, setPhoto] = useState(null); const [done, setDone] = useState(false); const [busy, setBusy] = useState(false);
  useEffect(() => { axios.get(`${API}/public/survey/${token}`).then(({ data }) => { setS(data); if (data.rating) setDone(true); }).catch((e) => setErr(e?.response?.data?.detail || "Link tidak valid")); }, [token]);
  const send = async () => {
    const fd = new FormData(); fd.append("rating", rating); fd.append("note", note); if (photo) fd.append("photo", photo);
    setBusy(true);
    try { await axios.post(`${API}/public/survey/${token}`, fd); setDone(true); } catch (e) { setErr(e?.response?.data?.detail || "Gagal mengirim"); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-amber-50 flex items-center justify-center p-5" data-testid="survey-page">
      <div className="w-full max-w-md bg-white rounded-3xl shadow-xl p-7">
        {err && <p className="text-rose-600 text-sm" data-testid="survey-error">{err}</p>}
        {s && done && <div className="text-center" data-testid="survey-done"><Face happy /><h1 className="text-2xl font-bold mt-3">Terima kasih!</h1><p className="text-sm text-slate-500 mt-1">Penilaian Anda sudah kami terima.</p></div>}
        {s && !done && <>
          <p className="text-xs uppercase tracking-widest text-slate-400">{s.company}</p>
          <h1 className="text-2xl font-bold mt-1">Apakah Anda merasa terbantu dengan {s.kind === "visit" ? "kunjungan" : "project"} di FOMU?</h1>
          <p className="text-sm text-slate-500 mt-1">{s.ref_label} · {s.customer_name}</p>
          <div className="grid grid-cols-2 gap-3 mt-6">
            {[["PUAS", "Puas", true], ["TIDAK_PUAS", "Tidak puas", false]].map(([k, l, h]) => (
              <button key={k} type="button" data-testid={`survey-${k}`} onClick={() => setRating(k)}
                className={`rounded-2xl border-2 p-4 flex flex-col items-center transition-transform hover:-translate-y-1 ${rating === k ? (h ? "border-amber-500 bg-amber-50" : "border-sky-500 bg-sky-50") : "border-slate-200"}`}>
                <Face happy={h} /><b className="mt-2">{l}</b></button>))}
          </div>
          {rating && <>
            <textarea data-testid="survey-note" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Catatan (opsional)" className="w-full mt-5 border border-slate-300 rounded-xl p-3 text-sm" rows={3} />
            <label className="block text-xs text-slate-500 mt-3">Lampirkan foto (opsional)<input type="file" accept="image/jpeg,image/png,image/webp" data-testid="survey-photo" onChange={(e) => setPhoto(e.target.files[0])} className="block mt-1 text-xs" /></label>
            <button type="button" disabled={busy} data-testid="survey-submit" onClick={send} className="w-full mt-5 rounded-full bg-slate-900 text-white py-3 font-semibold disabled:opacity-50">{busy ? "Mengirim…" : "Kirim penilaian"}</button>
          </>}
        </>}
      </div>
    </div>
  );
}
